import React from 'react';
import {Box, List, Card, Button, Typography, CardContent, ListItem, ListItemText, ListItemIcon, Stack, Link} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import InfoIcon from '@mui/icons-material/Info';

const DataLibrary = (): JSX.Element => {

    // list the last 20 years
    const downloadYears = Array.from(new Array(21), (val, index) => new Date().getFullYear() - index);

  return (
    <Box marginTop={5} marginBottom={4}>
      <Box marginBottom={4}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Explore the data
        </Typography>
        <Typography
          variant="h6"
          color={'text.secondary'}
          align={'center'}
          data-aos={'fade-up'}
        >
          Download campaign finance datasets for further research and analysis.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid size={{xs:12, md:5}} data-aos="fade-up">
            <Grid size={12}>
              <Box component={Card}>
                <CardContent>
                <Box component={List}>
                <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemIcon}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <InfoIcon color="primary" />
                    </Box>
                    <ListItemText sx={{fontStyle: "italic", fontWeight: 600}} primary={'Data downloads updated nightly at 3:30 AM'} />
                </Box>
                <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemIcon}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <InfoIcon color="primary" />
                    </Box>
                    <ListItemText sx={{fontStyle: "italic"}} primary={'The primary data format is tab-delimited text.'} />
                </Box>
                <Box
                    component={ListItem}
                    disableGutters
                    width={'auto'}
                    padding={0}
                  >
                    <Box
                      component={ListItemIcon}
                      minWidth={'auto !important'}
                      marginRight={2}
                    >
                      <InfoIcon color="primary" />
                    </Box>
                    <ListItemText sx={{fontStyle: "italic"}} primary={'Readme files are included with the data to provide some guidance.'} />
                </Box>
                </Box>
                <Typography
                    marginTop={2}
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{ color: 'common.black' }}
                  >
                    Please contact ocpf@mass.gov for any related questions.
                  </Typography>
                </CardContent>
              </Box>
            </Grid>
        </Grid>
        <Grid size={{xs:12, md:7}}>
          <Box
            padding={1}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
             <Typography
                variant="subtitle2"
                align={'left'}
                fontWeight={600}
                gutterBottom
                >
                Click to download report data by year
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {
                downloadYears.map((year) => (
                  <Box key={year} padding={1}>
                    <Button
                      variant={'outlined'}
                      color={'primary'}
                      size={'small'}
                      href={`https://ocpf2.blob.core.windows.net/downloads/data2/ocpf-${year}-reports.zip`}
                      rel={'noreferrer noopener'}
                    >
                      {year}
                    </Button>
                  </Box>
                ))
             }
            </Stack>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={3} display={'flex'} justifyContent={'center'}>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              component={Link}
              href='/Data/Downloads'
            >
              View More Data Downloads
            </Button>
          </Box>
    </Box>
  );
};

export default DataLibrary;
